module.exports = __webpack_public_path__ + "static/object-6-7b72ed9dac068bfe6a0e443c5225e298.png";